module.exports = __webpack_public_path__ + "media/images/welcome-companies-28e55535358ed9987304ea171b7a0402.svg";